import type { NuovoUtenteDTO, UtenteDTO } from '@/models/dto/utente/utente-dto'
import type { NewUser, User } from '@/models/types/user/user'
import { mapToFacility, mapToImpiantoDTO } from '../facility/facility-mapper'

const mapToUtentiDTO = (user: User): UtenteDTO => {
    return { ...mapToNuovoUtenteDTO(user), id: user.id }
}

const mapToUser = (utentiDTO: UtenteDTO): User => {
    return { ...mapToNewUser(utentiDTO), id: utentiDTO.id }
}

const mapToNuovoUtenteDTO = (user: NewUser): NuovoUtenteDTO => {
    return {
        nome: user.firstName ?? null,
        cognome: user.lastName ?? null,
        eMail: user.email ?? null,
        abilitaNotificheMail: user.emailNotificationEnabled ?? null,
        azienda: user.company ?? null,
        fotoProfiloBlobPath: user.profileImagePath ?? null,
        fotoProfiloUrl: user.profileImageURL ?? null,
        idRuolo: user.roleId ?? null,
        nomeRuolo: user.roleName ?? null,
        impianti: user.facilities?.map((facility) => mapToImpiantoDTO(facility)) ?? null,
    }
}

const mapToNewUser = (utentiDTO: NuovoUtenteDTO): NewUser => {
    return {
        firstName: utentiDTO.nome ?? undefined,
        lastName: utentiDTO.cognome ?? undefined,
        email: utentiDTO.eMail ?? undefined,
        emailNotificationEnabled: utentiDTO.abilitaNotificheMail ?? undefined,
        company: utentiDTO.azienda ?? undefined,
        roleId: utentiDTO.idRuolo ?? undefined,
        roleName: utentiDTO.nomeRuolo ?? undefined,
        profileImagePath: utentiDTO.fotoProfiloBlobPath ?? undefined,
        profileImageURL: utentiDTO.fotoProfiloUrl ?? undefined,
        facilities: utentiDTO.impianti?.map((impianto) => mapToFacility(impianto)) ?? undefined,
    }
}

export { mapToNewUser, mapToNuovoUtenteDTO, mapToUser, mapToUtentiDTO }
